export default "__VITE_ASSET__DmPopLU3__"